import { render, staticRenderFns } from "./DocEditor.vue?vue&type=template&id=4d7102aa&scoped=true&"
import script from "./DocEditor.vue?vue&type=script&lang=js&"
export * from "./DocEditor.vue?vue&type=script&lang=js&"
import style0 from "./DocEditor.vue?vue&type=style&index=0&id=4d7102aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7102aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4d7102aa', component.options)
    } else {
      api.reload('4d7102aa', component.options)
    }
    module.hot.accept("./DocEditor.vue?vue&type=template&id=4d7102aa&scoped=true&", function () {
      api.rerender('4d7102aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/DocEditor/DocEditor.vue"
export default component.exports